import { Inject, Injectable } from '@angular/core';
import { CommonService } from '@geneplanet/ngx-shop/src/lib/shared';
import {
  DEFAULT_LANGUAGE,
  MissingTranslationHandler,
  TranslateCompiler,
  TranslateLoader,
  TranslateParser,
  TranslateService,
  TranslateStore,
  USE_DEFAULT_LANG,
  USE_EXTEND,
  USE_STORE,
} from '@ngx-translate/core';
import { Observable } from 'rxjs';

/**
 * Custom translate service will convert LocationCode to LanguageCode.
 * This is to make sure TranslateService will always have language, not location.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomTranslateService extends TranslateService {
  constructor(
    store: TranslateStore,
    currentLoader: TranslateLoader,
    compiler: TranslateCompiler,
    parser: TranslateParser,
    missingTranslationHandler: MissingTranslationHandler,
    @Inject(USE_DEFAULT_LANG) useDefaultLang = true,
    @Inject(USE_STORE) isolate = false,
    @Inject(USE_EXTEND) extend = false,
    @Inject(DEFAULT_LANGUAGE) defaultLanguage: string,
    private commonService: CommonService
  ) {
    super(
      store,
      currentLoader,
      compiler,
      parser,
      missingTranslationHandler,
      useDefaultLang,
      isolate,
      extend,
      defaultLanguage
    );
  }

  public setDefaultLang(lang: string): void {
    super.setDefaultLang(
      this.commonService.getLanguageCodeFromLocationCode(lang)
    );
  }

  public use(lang: string): Observable<any> {
    return super.use(this.commonService.getLanguageCodeFromLocationCode(lang));
  }
}
